import {ScanQrCode} from './scan-qr-code';

document.addEventListener('DOMContentLoaded', () => {
  for (const container of document.querySelectorAll<HTMLElement>('[data-ctype="sfeventmgtth_scanqrcode"] [data-action="scanQrCode"]')) {
    new ScanQrCode(container);
  }
});
